"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.refundUpdatePayloadSchema = void 0;
var received_adjustment_1 = require("./received-adjustment");
exports.refundUpdatePayloadSchema = {
    type: 'object',
    required: ['receivedAdjustments', 'grossRefundBalance'],
    properties: {
        receivedAdjustments: {
            type: 'array',
            items: received_adjustment_1.receivedAdjustmentSchema,
        },
        grossRefundBalance: {
            type: 'number',
            maximum: 99999999,
            minimum: -99999999,
            decimal: [10, 2],
            errorMessage: 'Should be a decimal with up to 10 digits in total and 2 digits of precision',
        },
    },
};
